const FACE_AXES = Object.freeze({
  U: 'y',
  D: 'y',
  R: 'x',
  L: 'x',
  F: 'z',
  B: 'z',
});

const SCRAMBLE_FACES = Object.freeze(Object.keys(FACE_AXES));
const SCRAMBLE_SUFFIXES = Object.freeze(['', "'", '2']);

export const DEFAULT_SCRAMBLE_LENGTH = 15;
export const MIN_SCRAMBLE_LENGTH = 2;
export const MAX_SCRAMBLE_LENGTH = 50;

export const SCRAMBLE_ORDER_OPTIONS = Object.freeze([
  Object.freeze({ order: 2, label: '2×2', enabled: false }),
  Object.freeze({ order: 3, label: '3×3', enabled: true }),
  Object.freeze({ order: 4, label: '4×4', enabled: false }),
  Object.freeze({ order: 5, label: '5×5', enabled: false }),
]);

export function clampScrambleLength(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return DEFAULT_SCRAMBLE_LENGTH;
  return Math.min(Math.max(Math.round(parsed), MIN_SCRAMBLE_LENGTH), MAX_SCRAMBLE_LENGTH);
}

function secureRandom() {
  if (!globalThis.crypto?.getRandomValues) return Math.random();
  const values = new Uint32Array(1);
  globalThis.crypto.getRandomValues(values);
  return values[0] / 0x1_0000_0000;
}

function randomItem(items, random) {
  return items[Math.min(Math.floor(random() * items.length), items.length - 1)];
}

export function generateScramble3x3(length = DEFAULT_SCRAMBLE_LENGTH, { random = secureRandom } = {}) {
  const moveCount = clampScrambleLength(length);
  const moves = [];
  let previousAxis = null;

  while (moves.length < moveCount) {
    const availableFaces = SCRAMBLE_FACES.filter((face) => FACE_AXES[face] !== previousAxis);
    const face = randomItem(availableFaces, random);
    const suffix = randomItem(SCRAMBLE_SUFFIXES, random);
    moves.push(`${face}${suffix}`);
    previousAxis = FACE_AXES[face];
  }

  return Object.freeze({
    order: 3,
    moveCount,
    moves: Object.freeze(moves),
    formula: moves.join(' '),
  });
}

export function generateScramble2x2(length = 11, options = {}) {
  const scramble = generateScramble3x3(length, options);
  return Object.freeze({ ...scramble, order: 2 });
}

export function generateScramble(order, length, options) {
  const capability = SCRAMBLE_ORDER_OPTIONS.find((item) => item.order === Number(order));
  if (!capability?.enabled) throw new RangeError(`${order}×${order} 打乱公式暂未开放`);
  if (capability.order === 3) return generateScramble3x3(length, options);
  throw new RangeError(`暂不支持 ${order}×${order} 打乱公式`);
}

export function scrambleAxis(move) {
  return FACE_AXES[String(move)[0]] ?? null;
}
